import { get } from 'svelte/store';
import { z } from 'zod';
import { filter } from '../../../stores/filter';
import type { localStorageFilterType } from '../telematics/components/FilterByParameters/FilterManager';
import { SettingsApi } from '../Settings/SettingsApi';
import { api } from '../../../stores/api';
import type { QueriesType } from '../telematics/types';

export const resetFilterQuery = () => {
    // alert('Aby problem się nie powtórzył usuniemy zawartość filtrów');
    console.debug('resetFilterQuery: ', get(filter).connections.managerStorageKey);
    filter.update(f => {
        f.connections.queries = {};
        f.connections.quickSearch = '';
        return f;
    });

    let data: localStorageFilterType = {
        mainFilterData: {
            queries: {},
            related: [],
        },
        lastUsedFilterData: {
            queries: {},
            related: [],
            historyOfAddedKeys: [],
        },
        __inactiveQueriesKeys: [],
        __andOrSelection: 'and',
    };
    SettingsApi.setClientSettings<localStorageFilterType>(
        get(api),
        get(filter).connections.managerStorageKey || '',
        data,
        z.any()
    );
};

export const getFilterQuery = () => {
    let queries = {};
    let queryToProcess = { ...get(filter).connections.queries };
    let quickSearch = get(filter).connections.quickSearch;
    let quickSearchOr = [];
    let queryOr = [];
    let queryAnd: QueriesType = {};

    if (typeof queryToProcess['location_type'] !== 'undefined') {
        queryOr.push({
            'location_from.location_type': queryToProcess['location_type'],
        });
        queryOr.push({
            'location_to.location_type': queryToProcess['location_type'],
        });
        delete queryToProcess['location_type'];
    }

    queryAnd = { ...queryToProcess };
    //
    // if (typeof queryToProcess['calculation_result.route_length'] !== 'undefined') {
    //     queryAnd = {
    //         ...queryAnd,
    //         'calculation_result.route_length': queryToProcess['calculation_result.route_length'],
    //     };
    // }

    if (typeof queryToProcess['route_length'])
        if (quickSearch !== '') {
            if (typeof queryToProcess['address_attributes.city'] === 'undefined') {
                quickSearchOr.push({
                    'location_from.address_attributes.city': {
                        $ilike: '%' + quickSearch + '%',
                    },
                });
                quickSearchOr.push({
                    'location_to.address_attributes.city': {
                        $ilike: '%' + quickSearch + '%',
                    },
                });
            }
            if (typeof queryToProcess['address_attributes.street'] === 'undefined') {
                quickSearchOr.push({
                    'location_from.address_attributes.street': {
                        $ilike: '%' + quickSearch + '%',
                    },
                });
                quickSearchOr.push({
                    'location_to.address_attributes.street': {
                        $ilike: '%' + quickSearch + '%',
                    },
                });
            }
            if (typeof queryToProcess['ext_id'] === 'undefined') {
                // ex. AAA-BBB
                // if in quickSearch is '-' then we are looking for ext_id AAA in location_from.ext_id and BBB in location_to.ext_id
                if (quickSearch.includes('-')) {
                    let [from, to] = quickSearch.split('-');
                    quickSearchOr.push({
                        $and: [
                            { 'location_from.ext_id': { $ilike: from } },
                            { 'location_to.ext_id': { $ilike: to + '%' } },
                        ],
                    });
                } else if (quickSearch.includes('=')) {
                    let [from, to] = quickSearch.split('=');
                    quickSearchOr.push({
                        $and: [
                            { 'location_from.ext_id': { $ilike: from } },
                            { 'location_to.ext_id': { $ilike: to + '%' } },
                        ],
                    });
                    quickSearchOr.push({
                        $and: [
                            { 'location_from.ext_id': { $ilike: to + '%' } },
                            { 'location_to.ext_id': { $ilike: from } },
                        ],
                    });
                }

                quickSearchOr.push({
                    'location_from.ext_id': { $ilike: '%' + quickSearch + '%' },
                });
                quickSearchOr.push({
                    'location_to.ext_id': { $ilike: '%' + quickSearch + '%' },
                });
            }
            if (typeof queryToProcess['full_name'] === 'undefined') {
                quickSearchOr.push({
                    'location_from.full_name': {
                        $ilike: '%' + quickSearch + '%',
                    },
                });
                quickSearchOr.push({
                    'location_to.full_name': {
                        $ilike: '%' + quickSearch + '%',
                    },
                });
            }
            if (typeof queryToProcess['address_attributes.pcode'] === 'undefined') {
                quickSearchOr.push({
                    'location_from.address_attributes.pcode': {
                        $ilike: '%' + quickSearch + '%',
                    },
                });
                quickSearchOr.push({
                    'location_to.address_attributes.pcode': {
                        $ilike: '%' + quickSearch + '%',
                    },
                });
            }
        }

    if (Object.keys(queryOr).length > 0) {
        queries = { $or: { ...queryOr, ...quickSearchOr } };
    } else {
        queries = { $or: quickSearchOr };
    }

    if (Object.keys(queryAnd).length > 0) {
        queries = { $and: [queryAnd], ...queries };
    }

    console.log('queries', queries);

    return queries;
};
